import { useTranslation } from "react-i18next";

import { Grid } from "@mui/material";
import { FormInput, SwitchInput } from "@4uhub/lib4uhub";

import { buildTPath } from "../beneficiary-termination-reason.utils";

const Fields = () => {
  const { t } = useTranslation();

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} textAlign="end">
          <SwitchInput name="enable" label={t(buildTPath("enabled"))} />
        </Grid>

        <Grid item xs={12} sm={12}>
          <FormInput
            size="small"
            name="name"
            fullWidth
            label={t(buildTPath("name"))}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default Fields;
